/**
 * @desc 批量新增列字段
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.TableColumnBatchAddRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tableColumn/batch/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
